import type { PersonaKey } from '@/shared/domain'
import { NAV_ENTRIES, type NavEntry } from './sidebar-nav'

export type NavVisibilityOptions = {
  clubFeaturesHidden?: boolean
}

function isEntryEnabled(entry: NavEntry): boolean {
  return entry.isEnabled ? entry.isEnabled() : true
}

function isChildVisible(
  child: NavEntry,
  persona: PersonaKey,
  options: NavVisibilityOptions,
): boolean {
  if (!child.personas.includes(persona)) return false
  if (!isEntryEnabled(child)) return false
  if (options.clubFeaturesHidden && child.id === 'finances-member-ledger') return false
  return true
}

export function visibleNavEntriesForPersona(
  persona: PersonaKey,
  options: NavVisibilityOptions = {},
): NavEntry[] {
  return NAV_ENTRIES.flatMap((entry) => {
    if (entry.children) {
      const visibleChildren = entry.children.filter((child) =>
        isChildVisible(child, persona, options),
      )
      if (visibleChildren.length === 0) return []
      if (entry.flattenForPersonas?.includes(persona)) return visibleChildren
      return [{ ...entry, children: visibleChildren }]
    }
    if (!isEntryEnabled(entry)) return []
    return entry.personas.includes(persona) ? [entry] : []
  })
}

export function moduleRootFromPath(pathname: string): string {
  const segment = pathname.split('/').filter(Boolean)[0]
  return segment ? `/${segment}` : '/'
}

export function isPathVisibleForPersona(
  pathname: string,
  persona: PersonaKey,
  options: NavVisibilityOptions = {},
): boolean {
  const moduleRoot = moduleRootFromPath(pathname)
  return visibleNavEntriesForPersona(persona, options).some((entry) => {
    if (entry.to === moduleRoot) return true
    return (entry.children ?? []).some((child) => child.to === moduleRoot)
  })
}
